// extracted by mini-css-extract-plugin
export default {"main":"Pics_main__cwcsP","prev":"Pics_prev__rtiaA","imageRed":"Pics_imageRed__02Vju","backbutton":"Pics_backbutton__Qyc0x"};